/**
 * Contador aislado para dual-promo-offers.
 * No depende de countdown-timer global.
 */
if (!customElements.get('dual-promo-countdown')) {
  class DualPromoCountdown extends HTMLElement {
    constructor() {
      super();
      const timezone = this.dataset.timezone;
      const dateParts = this.dataset.date.split('-').filter((el) => el !== '');
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);

      let tarhour = 0;
      let tarmin = 0;
      const time = this.dataset.time;
      if (time != null) {
        const timeParts = time.split(':');
        tarhour = parseInt(timeParts[0], 10);
        tarmin = parseInt(timeParts[1], 10);
      }

      const dateString =
        month +
        '/' +
        day +
        '/' +
        year +
        ' ' +
        (tarhour < 10 ? '0' + tarhour : tarhour) +
        ':' +
        (tarmin < 10 ? '0' + tarmin : tarmin) +
        ' GMT' +
        timezone;

      this.countDownDate = new Date(dateString).getTime();
      this.timerInterval = null;
      this.lastDays = -1;
      this.lastHours = -1;
      this.lastMinutes = -1;
    }

    connectedCallback() {
      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    startTimer() {
      this.updateTime(true);
      this.timerInterval = setInterval(() => this.updateTime(false), 1000);
    }

    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }

    updateTime(initialUpdate = false) {
      const now = new Date().getTime();
      const distance = this.countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysBlock = this.querySelector('.dual-promo-offers__countdown-col--days .dual-promo-offers__countdown-num');
      const hoursBlock = this.querySelector('.dual-promo-offers__countdown-col--hours .dual-promo-offers__countdown-num');
      const minutesBlock = this.querySelector('.dual-promo-offers__countdown-col--minutes .dual-promo-offers__countdown-num');
      const secondsBlock = this.querySelector('.dual-promo-offers__countdown-col--seconds .dual-promo-offers__countdown-num');
      const cols = this.querySelector('.dual-promo-offers__countdown-cols');
      const endedMsg = this.querySelector('.dual-promo-offers__countdown-ended');

      if (distance < 0) {
        this.stopTimer();
        if (daysBlock) daysBlock.textContent = '0';
        if (hoursBlock) hoursBlock.textContent = '0';
        if (minutesBlock) minutesBlock.textContent = '0';
        if (secondsBlock) secondsBlock.textContent = '0';
        this.classList.add('loading-effect');
        this.setAttribute('data-is-ended', 'true');
        if (cols) cols.classList.add('hidden');
        if (endedMsg) endedMsg.classList.remove('hidden');
        return;
      }

      if (secondsBlock) secondsBlock.textContent = DualPromoCountdown.addZero(seconds);

      if (initialUpdate || this.lastMinutes !== minutes) {
        if (minutesBlock) minutesBlock.textContent = DualPromoCountdown.addZero(minutes);
        this.lastMinutes = minutes;
      }

      if (initialUpdate || this.lastHours !== hours) {
        if (hoursBlock) hoursBlock.textContent = DualPromoCountdown.addZero(hours);
        this.lastHours = hours;
      }

      if (initialUpdate || this.lastDays !== days) {
        if (daysBlock) daysBlock.textContent = DualPromoCountdown.addZero(days);
        this.lastDays = days;
      }

      if (days === 0 && daysBlock && !initialUpdate) {
        daysBlock.closest('.dual-promo-offers__countdown-col--days')?.remove();
      }

      this.classList.remove('loading-effect');
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? '0' + x : x;
    }
  }

  customElements.define('dual-promo-countdown', DualPromoCountdown);
}
